module.exports = __webpack_public_path__ + "img/XT1.8fbeabbe.png";